/**
 * Method 'getCookie' gets cookie with provided name.
 * @param {String} name - Name of the cookie
 * @return {null | String } - description of each case:
 * null there is not cookie
 * string with value of cookie
 * string[] array of value of cookies (several cookies of the same name were found)
 */
export const getCookie = (name) => {
    const matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
    return matches && matches[1] ? decodeURIComponent(matches[1]) : null;
};
